import React, { useState, useEffect } from 'react';
import { User, Note } from '../types';
import { initialNotes } from '../data/mockData';
import { useLanguage } from '../i18n/LanguageContext';

interface ReflectionSectionProps {
    user: User | null;
    lessonSlug: string;
}

const ReflectionSection: React.FC<ReflectionSectionProps> = ({ user, lessonSlug }) => {
    const { t } = useLanguage();
    const [note, setNote] = useState('');
    const [savedNotes, setSavedNotes] = useState<Note[]>([]);

    useEffect(() => {
        // In a real app, you would fetch this for the current user
        setSavedNotes(initialNotes.filter(n => n.lesson_slug === lessonSlug));
    }, [lessonSlug]);


    const handleSaveNote = () => {
        if (!user || !note.trim()) return;
        const newNote: Note = {
            id: `note-${Date.now()}`,
            user_id: user.id,
            template: 'refleksjon',
            content: note,
            timestamp: new Date().toISOString(),
            lesson_slug: lessonSlug,
        };
        // In a real app, this would be an API call
        setSavedNotes(prev => [...prev, newNote]);
        setNote('');
    };

    return (
        <div className="bg-white/60 p-8 rounded-4xl shadow-lg border border-white/50">
            <h2 className="text-2xl font-bold mb-4">{t('lessonDetail.reflection')}</h2>
            {user ? (
            <>
                <p className="text-stone-600 mb-4">{t('lessonDetail.reflectionPrompt')}</p>
                <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder={t('lessonDetail.placeholder')}
                className="w-full p-4 rounded-2xl border border-stone-200 focus:ring-2 focus:ring-accent focus:outline-none transition-shadow h-32 resize-none"
                ></textarea>
                <button
                onClick={handleSaveNote}
                className="mt-4 px-6 py-2.5 text-base font-medium text-center text-white bg-accent rounded-full hover:bg-accent-dark focus:ring-4 focus:ring-accent/50 disabled:bg-stone-300"
                disabled={!note.trim()}
                >
                {t('lessonDetail.saveNote')}
                </button>
                {savedNotes.length > 0 && (
                    <div className="mt-8">
                        <h3 className="font-semibold text-lg mb-3">{t('lessonDetail.previousNotes')}</h3>
                        <div className="space-y-3">
                            {savedNotes.map(n => (
                                <div key={n.id} className="bg-white p-4 rounded-xl border border-stone-200">
                                    <p className="text-stone-700">{n.content}</p>
                                    <p className="text-xs text-stone-400 mt-2">{new Date(n.timestamp).toLocaleString()}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </>
            ) : (
            <div className="text-center p-6 border-2 border-dashed border-stone-300 rounded-2xl">
                <p className="text-stone-600">{t('lessonDetail.loginToSave')}</p>
            </div>
            )}
        </div>
    );
};

export default ReflectionSection;
